var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardnum10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0407,
    cy: 10.8156,
    r: 10.0226,
    fill: "#320620"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09053 6.81543H7.93053V13.8154H6.81053V8.68543H5.33053V7.73543C6.42053 7.73543 6.92053 7.50543 7.09053 6.81543ZM13.8838 10.3054C13.8838 11.4354 13.6738 12.3254 13.2538 12.9754C12.8338 13.6254 12.2438 13.9454 11.4738 13.9454C10.7038 13.9454 10.1138 13.6254 9.69381 12.9754C9.27381 12.3254 9.06381 11.4354 9.06381 10.3054C9.06381 9.18543 9.27381 8.30543 9.69381 7.65543C10.1138 7.00543 10.7038 6.68543 11.4738 6.68543C12.2438 6.68543 12.8338 7.00543 13.2538 7.65543C13.6738 8.30543 13.8838 9.18543 13.8838 10.3054ZM10.2038 10.3054C10.2038 11.9454 10.6338 12.8954 11.4738 12.8954C12.3138 12.8954 12.7438 11.9454 12.7438 10.3054C12.7438 8.67543 12.3138 7.73543 11.4738 7.73543C10.6338 7.73543 10.2038 8.67543 10.2038 10.3054Z",
    fill: "#FBBB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardnum10);
export default __webpack_public_path__ + "static/media/cardnum10.355082f851e02f35d5c4a7af824b9234.svg";
export { ForwardRef as ReactComponent };